// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"d96d7e12","186":"f4c35a5a","453":"15ecd41f","531":"e71f781a","625":"7601bc64","649":"64115b1a","652":"dce5e3be","674":"a95dc2cc","900":"d8a3d064"}[chunkId] + ".chunk.js";
};